export default function AnnouncementBar() {
  return (
    <div className="relative mt-[6.5rem] md:mt-[6.5rem] bg-black text-white font-bold text-lg md:text-xl">
  <div className="flex whitespace-nowrap animate-scroll">
    <span className="uppercase mx-8">
      $FMEX Presale is Live! Early buyers get in 40x cheaper
    </span>
    <span className="uppercase mx-8">
      $FMEX Presale is Live! Early buyers get in 40x cheaper
    </span>
    <span className="uppercase mx-8">
      $FMEX Presale is Live! Early buyers get in 40x cheaper
    </span>

    {/* duplicate once */}
    <span className="uppercase mx-8">
      $FMEX Presale is Live! Early buyers get in 40x cheaper
    </span>
    <span className="uppercase mx-8">
      $FMEX Presale is Live! Early buyers get in 40x cheaper
    </span>
    <span className="uppercase mx-8">
      $FMEX Presale is Live! Early buyers get in 40x cheaper
    </span>
  </div>
</div>
  );
}
